import classnames from 'classnames';

import styles from 'molecules/Stats/featured-text-stats.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { ComponentPropsWithoutRef, FC } from 'react';

export interface FeaturedTextStatsProps extends ComponentPropsWithoutRef<'div'> {
  featuredStats: { title?: string; body?: string }[];
  statClass?: string;
}

const FeaturedTextStats: FC<FeaturedTextStatsProps> = ({ featuredStats, statClass, className = '' }) => (
  <div className={classnames(styles.statsContainer, { [className]: className })}>
    {isNonEmptyArray(featuredStats) &&
      featuredStats.map(({ title = '', body = '' }, index) => (
        <div key={`${index}-${title}`} className={statClass}>
          {title && <p className={styles.statsTitle}>{title}</p>}
          {body && <p className={styles.statsBody}>{body}</p>}
        </div>
      ))}
  </div>
);

export default FeaturedTextStats;
